import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api/client'
import type { LicenseRecord } from '../shared/types'

function downloadJson(data: unknown, filename: string) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export const useInstallationLicenses = (installationId: string) =>
  useQuery({
    queryKey: ['licenses', installationId],
    queryFn: () => api.get<LicenseRecord[]>(`/api/v1/installations/${installationId}/licenses`),
    enabled: !!installationId,
  })

export function useCreateLicenseRequest() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ installationId, reason }: { installationId: string; reason: string }) =>
      api.post<{ license_id: string; sequence: number; status: string }>(`/api/v1/installations/${installationId}/license-requests`, { reason }),
    onSuccess: (_d, v) => void qc.invalidateQueries({ queryKey: ['licenses', v.installationId] }),
  })
}

export function useExportLicenseRequests() {
  return useMutation({
    mutationFn: async () => {
      const data = await api.get<{ format: number; requests: unknown[] }>('/api/v1/license-requests/export')
      downloadJson(data, 'license-requests-export.json')
      return data
    },
  })
}

export function useDownloadLicenseEnvelope() {
  return useMutation({
    mutationFn: ({ installationId, licenseId, sequence }: { installationId: string; licenseId: string; sequence: number }) =>
      api.download(`/api/v1/installations/${installationId}/licenses/${licenseId}/envelope`, `license-${sequence}.json`),
  })
}
